import {
  auth, functions,
} from '@/shared/services/firebase'
import axios from '@hw-core/libs/axios'

export default {
  namespaced: true,
	state: {},
	getters: {},
	mutations: {},
  actions: {
    createZendeskTicket(ctx, { requester, groupId, message, subject, collaborators }) {
			return new Promise((resolve, reject) => {
				axios
					.post(`${functions.url}/createZendeskTicket`, {
						requester,
						groupId,
						message,
						subject,
						collaborators,
					})
					.then(response => resolve(response))
					.catch(error => {
						reject(error)
					})
			})
		},
		sendSMS(ctx, { mobile, message }) {
			return new Promise((resolve, reject) => {
				auth.currentUser
					.getIdToken(true)
					.then(idToken => {
						axios
							.post(`${functions.url}/sendSMSMessage`, { to: mobile, message, token: idToken })
							.then(response => resolve(response))
							.catch(error => reject(error))
					})
					.catch(error => {
						reject(error)
					})
			})
		},
		sendInterviewEmail(ctx, { to, message, subject }) {
			return new Promise((resolve, reject) => {
				axios
					.post(`${functions.url}/sendEmail`, { to, message, subject })
					.then(response => resolve(response))
					.catch(error => reject(error))
			})
		},
		sendWelcomeEmail(ctx, { firstName, email, pass, role, residency }) {
			return new Promise((resolve, reject) => {
				axios
					.post(`${functions.url}/sendWelcomeEmail`, { firstName, email, pass, role, residency })
					.then(response => resolve(response))
					.catch(error => reject(error))
			})
		},
  }
}